import {
  Divider,
  Card,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Grid
} from '@mui/material';

import LockIcon from '@mui/icons-material/Lock';

const NoPermissionContent = () => {
  return (
    <Card>
      <Divider />
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center">
                <Grid>
                  <LockIcon />
                </Grid>
                <Grid color="red" fontSize={30}>
                  Access Denied!
                </Grid>
                <Grid>You don't have permission to access this feature</Grid>
              </TableCell>
            </TableRow>
          </TableHead>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default NoPermissionContent;
